import { Monitor } from "../Models/Monitor";
import { Product } from "../Models/Product";
import { getApi, postApi } from "./Api";



export const addMonitor = async (monitor:Monitor) => {
    try{
        return await postApi<{message:string}>('monitor/add-monitor',monitor)
    }
    catch(error){
        throw error;
    }
}